import { render, staticRenderFns } from "./fancy-checkbox.vue?vue&type=template&id=28312114&scoped=true&lang=pug&"
import script from "./fancy-checkbox.vue?vue&type=script&lang=js&"
export * from "./fancy-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./fancy-checkbox.vue?vue&type=style&index=0&id=28312114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28312114",
  null
  
)

export default component.exports